var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProperty = function SvgProperty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m23.687 9.178-8.032-6.057a.602.602 0 0 0-.723 0l-1.32.996-1.32-.996a.602.602 0 0 0-.723 0l-1.288.97-1.288-.97a.6.6 0 0 0-.722 0L.239 9.178a.6.6 0 0 0-.239.48v10.197a.6.6 0 0 0 .6.6h22.726a.6.6 0 0 0 .6-.6V9.657a.6.6 0 0 0-.24-.479zm-.961 10.077h-2.164V9.657a.6.6 0 0 0-.238-.479l-5.716-4.31.685-.517 7.433 5.605v9.3zm-5.461 0V9.657a.6.6 0 0 0-.24-.479l-5.747-4.335.652-.491 7.432 5.604v9.3h-2.097zm-7.65 0H7.65v-4.35h1.965v4.35zm1.2 0v-4.95a.6.6 0 0 0-.6-.6H7.05a.6.6 0 0 0-.6.6v4.95H1.2V9.956l7.432-5.605 7.433 5.605v9.3h-5.25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
};
export default SvgProperty;